<template>
	<div class="cart-card-fast-checkout">
		<Select
			class="cart-card-fast-checkout__select"
			:label="$t('companion.keycardHeading')"
			:lightTheme="true"
			:option-items="[
				{
					id: 'new',
					text:
						'Nytt keycard (' +
						convertPrice(product.keycardPrice) +
						' ' +
						cart.currency +
						')'
				},
				{ id: 'existing', text: 'Befintligt keycard' }
			]"
			:value="
				product.keynumber
					? 'existing'
					: showExistingKeycard
					? 'existing'
					: 'new'
			"
			@input="onChangeKeycardType"
		/>

		<template v-if="product.keynumber ? false : showNewKeycard">
			<p v-html="$t('cart.newKeycardInfo')"></p>
		</template>

		<template v-if="product.keynumber ? true : showExistingKeycard">
			<!-- Key number input -->
			<InputComponent
				:defaultValue="product.keynumber"
				:id="product.uniqueId"
				:label="$t('companion.keycardInputLabel')"
				:placeholderValue="$t('companion.keycardInputText')"
				:type="'tel'"
				:lightTheme="true"
				:hasError="showKeycardError"
				:isValid="showKeycardSuccess"
				v-model="keynumber"
			></InputComponent>
			<!-- @input-enter="retry()" -->

			<!-- Key number error text -->
			<p v-if="showKeycardError" class="error">
				{{ $t('companion.keycardError') }}
			</p>

			<!-- Validation -->
			<Button
				@click.native="validateKeycard"
				:loading="loading"
				size="small"
				class="cart-card-fast-checkout__button"
			>
				<!-- {{ $t('newaccount.updateGuest') }} -->
				Validera keycardnummer
			</Button>

			<!-- Key number success text -->
			<p>
				<span v-if="showKeycardSuccess" class="">Grattis!</span>
				{{ $t('cart.existingKeycardInfo') }}
			</p>
		</template>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'
import '../../utilities/helper.js'

import Select from '../atoms/Select'
import InputComponent from '../atoms/InputComponent'
import Button from '../atoms/Button'

export default {
	name: 'CartCardFastCheckout',
	store,
	mixins: [mixin],
	components: {
		Select,
		InputComponent,
		Button
	},
	data() {
		return {
			showNewKeycard: true,
			showExistingKeycard: false,
			showKeycardError: false,
			showKeycardSuccess: false,
			loading: false,
			keynumber: ''
		}
	},
	props: {
		product: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		cart() {
			return store.state.cart
		}
	},
	methods: {
		onChangeKeycardType(val) {
			//New kaycard
			if (val == 'new') {
				this.showNewKeycard = true
				this.showExistingKeycard = false

				//Existing keycard
			} else if (val == 'existing') {
				this.showExistingKeycard = true
				this.showNewKeycard = false
			}

			this.showKeycardSuccess = false
			this.showKeycardError = false

			this.addOrUpdateKeycard('')
			this.keynumber = ''
		},
		validateKeycard() {
			// this.showKeycardSuccess = false
			// this.showKeycardError = false

			// if (this.validate()) {
			//store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
			//if (response) {
			if (this.keynumber == '') {
				//sätt keynumber på produkten i cart till ''
				this.addOrUpdateKeycard('')
				this.showKeycardSuccess = false
				this.showKeycardError = true
			} else {
				this.loading = true
				this.showKeycardSuccess = false
				this.showKeycardError = false
				store
					.dispatch('GET_KEY_CARD_VALIDATION', this.keynumber)
					.then(success => {
						if (success.length && success[0].valid) {
							this.loading = false
							this.showKeycardSuccess = true
							//sätt keynumber på produkten i cart till this.keynumber
							this.addOrUpdateKeycard(this.keynumber)
						} else {
							this.loading = false
							this.showKeycardError = true
						}
					})
					.catch(function (error) {
						window.error(error)
						this.loading = false
					})
			}
			//} else {
			//this.loading = false
			//}
			//})
			// } else if (this.guest.keynumber != '' && this.keycardValid == false) {
			// 	this.showKeycardError = true
			// }
		},
		addOrUpdateKeycard(val) {
			this.loading = true
			store
				.dispatch('GET_CART_SKIPASS_KEYCARD', {
					value: val,
					uniqueId: this.product.uniqueId
				})
				.then(success => {
					if (success) {
						this.showSuccess = true
					}
					this.loading = false
					//this.cart.skischool = store.state.cart.skischool
				})
				.catch(function (error) {
					window.console.error(error)
					this.loading = false
				})
		}
	}
}
</script>

<style lang="scss" scoped>
.cart-card-fast-checkout {
	&__select {
		margin-bottom: 20px;
	}

	&__button {
		margin-bottom: 20px;
	}

	.error {
		color: $colorRed;
		margin: -15px 0 20px;
	}
}
</style>
